import React from 'react'

export default function GridLoader({ children }) {
  return (
    <div className="grid-loader">
      { children }
    </div>
  );
}